/**
 * Created by phatbass on 1/29/16.
 */

angular.module('dekky.forms.autocomplete', [])
    .service('autocomplete', function ($http, $q) {
        var objects = {};
        var self = this;
        var timeout = null;

        this.check = function (object) {
            if (objects[object] === undefined) {
                objects[object] = [];
            }
        };

        this.get = function (object) {
            self.check(object);

            return objects[object];
        };

        this.refreshAutoComplete = function (search, term, object, options) {
            if (object) {
                self.check(object);

                objects[object].length = 0;
            }

            if (!search) {
                if (object) {
                    return self.get(object);
                } else {
                    return $q.when([]);
                }
            }

            var params = {
                term: term,
                search: search
            };

            if (angular.isObject(options)) {
                params = angular.extend(params, options);
            }

            return $http.post(Routing.generate('api_entities_post_autocomplete'), params)
                .then(function (response) {
                    if (object) {
                        objects[object].length = 0;

                        response.data.forEach(function (route) {
                            objects[object].push(route);
                        });
                    } else {
                        return response.data;
                    }
                });
        }
    });